module.exports = __webpack_public_path__ + "static/media/logo.bafd0b41.svg";